import type { AxiosInstance } from "axios";
import type { TranslateFn, U2000ApiErrorResult } from "../u2000Core/axios/U2000HandleApiError";
import type { U2000SearchPayload } from "../u2000Core/components/tables/basic/U2000BasicTable";

const U2202_URL = "U2202";

const U2202Endpoints = {
  SEARCH: `${U2202_URL}/search`,
  INITLU: `${U2202_URL}/initLU`,
} as const;

export interface U2202ConnectedUser {
  id: string;
  userId: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  connectionCount: number;
}

export interface U2202InitLU {
  launchSearch: boolean;
  hideSearch: boolean;
  nbRecordPerPage: number;
}

export const defaultU2202InitLU: U2202InitLU = {
  launchSearch: true,
  hideSearch: true,
  nbRecordPerPage: 50,
};

export const doSearch = (axios: AxiosInstance, searchPayload: U2000SearchPayload) => {
  return axios.post(U2202Endpoints.SEARCH, searchPayload);
};

export const doInitLU = (axios: AxiosInstance) => {
  return axios.get(U2202Endpoints.INITLU);
};

export function luHandleAppiError(
  _t: TranslateFn,
  _NS: string,
  _err: unknown,
  _errorResult: U2000ApiErrorResult
): void {
  // Pas d'erreurs métier spécifiques U2202 pour l'instant
}
